module.exports = __webpack_public_path__ + "img/uk-tuberculosis-male.adec4a8c.png";